// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { TaskStatusEnum } from '~/utils/enum/common';
import { IFormJobTask } from '~/utils/interface/job';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      title: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      dueDate: yup.string().trim().optional(),
      accountId: yup.string().trim().optional(),
      description: yup.string().trim().optional(),
      status: yup.string().trim().optional(),
    })
    .required();
};

export const defaultValuesForm: IFormJobTask = {
  title: EMPTY_STRING,
  dueDate: EMPTY_STRING,
  accountId: EMPTY_STRING,
  description: EMPTY_STRING,
  status: TaskStatusEnum.TO_DO,
};
